module.exports = __webpack_public_path__ + "static/media/SerieSP.5ca92353.pdf";